export type TemplateImportSteps =
    | 'AddButtonClicked'
    | 'AddExistingOFT'
    | 'CreateNewTemplate'
    | 'Add'
    | 'ValidationFailed'
    | 'MissingData'
    | 'OftImportSuccess'
    | 'ImportException'
    | 'Cancel'
    | 'Template Import Dialog Opened'
    | 'DialogOpened'
    | 'TemplateCreated'
    | 'CreateNewTemplateCancel'
    | 'PathCopied'
    | 'Choose'
    | 'NewMailFromTemplate'
    | 'TemplateSelected'
    | 'ManageTemplatesClicked'
    | 'TemplateDialogCancelled'
    | 'SaveAsTemplate'
    | 'MailTemplatesButtonClicked';

export type TemplateImportStepOptions =
    | {
          fileCount: number;
      }
    | {
          isBulkImport: boolean;
      };

interface FunnelStepEntry {
    step: TemplateImportSteps;
    options?: TemplateImportStepOptions;
}

const importSteps: FunnelStepEntry[] = [];

const MAX_FUNNEL_STEPS = 20;

export function logTemplateImportSteps(
    step: TemplateImportSteps,
    options?: TemplateImportStepOptions
): void {
    if (importSteps.length >= MAX_FUNNEL_STEPS) {
        importSteps.shift();
    }
    importSteps.push({ step, options });
}

export function getTemplateImportSteps(): readonly FunnelStepEntry[] {
    return importSteps.slice();
}
